import React, { useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";

// interface
import { UserTypes } from "../../../data/chat";
import { STATUS_TYPES } from "../../../constants";
import { Utils } from "helpers/utils";
import UserAvatar from "components/UserAvatar";
import { ChatContact2 } from "redux/chats/slice";

interface ChatContact2Props {
  user: ChatContact2;
  selectedChat: string | number;
  onSelectChat: (id: number | string) => void;
  is2s?: boolean | null;
  visible?: boolean;
  keyIndex?: number;
}
const ChatUser2 = ({ user, selectedChat, onSelectChat, is2s = false, visible = true, keyIndex }: ChatContact2Props) => {
  //const fullName = `${user.firstName} ${user.lastName}`;
  //console.log('ChatContact2.user:', user);
  const fullName = /*keyIndex + '. ' + */(is2s ? `${user.fullName}` : `ห้องสนทนากับ ${process.env.REACT_APP_COMPANY_ABBR}`);
  // const unRead = user.meta && user.meta.unRead;
  const unRead = user?.unreadCount;
  const lastChatTime = user?.lastChatTime;
  const lastChatText = user?.lastChatText;
  const unreadTagMe = (user as any)?.unreadTagMe > 0;
  const css_unread = localStorage.getItem("lm") == "dark" ? "badge-soft-dark" : "badge-soft-light";

  const isSelectedChat: boolean =
    selectedChat && selectedChat === user.userId ? true : false;
  const onClick = () => {
    onSelectChat(user.userId);
  };

  const ComponentMain = () => {
    return (
      <li className={classnames({ active: isSelectedChat })} onClick={onClick}>
        <Link to="#" className={classnames({ "unread-msg-user": unRead })}>
          <div className="d-flex align-items-center ">
            <div
              className={classnames(
                "chat-user-img", 
                "align-self-center",
                "me-2",
                "ms-0",
                { online: false }
              )}
            >

              <UserAvatar
                profileImage={user.profileImage}
                bgColor={user.bgColor}
                foreColor={user.foreColor}
                abbrName={user.abbrName}
              //abbrName={(keyIndex??-1 + 1).toString()}
              />
            </div>
            <div className="overflow-hidden">
              <p className="text-truncate mb-0">
                {is2s && (<>
                  {!user.companyId && (<span className="text-red mdi mdi-account-off-outline" title="ยังไม่ได้จับคู่บริษัทใน dconnect"></span>)}
                  {(user.companyId && (user.isSaleCorrect == false || user.isCsCorrect == false)) && <span className="text-warning bx bxs-group" title="Sale/CS ไม่อยู่ในห้องแชท"></span>}
                </>)}
                <span>{fullName}</span>
              </p>
              <p className="text-truncate mb-0 last-chat-text">
                {unreadTagMe && (<span style={{ color: "blue" }}>มีผู้กล่าวถึงคุณ </span>)}
                {lastChatText}</p>
            </div>
            <div className="ms-auto text-end">
              <p className="text-truncate mb-0 " >
                <span className={"last-chat-time p-1 "}>{Utils.GetShortDateTimeToShowInChat(lastChatTime, true)}</span>
              </p>
              {unRead && unRead > 0 ? (
                <p className="text-truncate mb-0 unread-badge-p" >
                  <span className={"badge " + css_unread + " unread-badge rounded p-1 "}>{unRead}</span>
                </p>
              ) : null}
            </div>

            {/* {unRead && unRead !== 0 ? ( */}


            {/* {unRead && unRead !== 0 ? (
              <div className="ms-auto">
                <span className={"badge " + css_unread + " rounded p-1"}>
                  {unRead}
                </span>
              </div>
            ) : null} */}
          </div>
        </Link>
      </li >
    )
  }

  return (visible ? (<ComponentMain />) : null);

};

export default ChatUser2;
